<template>
  <div
    v-if="!isLoaded"
    class="loading_screen flex_col space_around align_center"
  >
    <div class="flex_col align_center space_around">
      <div>Fabricating...</div>
      <img class="spinning_tee margin_0_auto" src="/img/tee_spin.gif" />
    </div>
  </div>
  <div v-else class="nftee_page_container mt-4 mb-2">
    <div class="cover row">
      <div
        class="
          col-12 col-md-6
          text-center
          flex_col
          align_center
          space_around
          pa-0
        "
      >
        <div class="mb-6 flex_col align_center">
          <img
            id="header_winkled_sigil"
            class="mt-2"
            src="/img/WrinkledSigil.png"
          />
          <h1 class="heading1 mt-4">NUMERAI NFTEES</h1>
          <p class="sub_heading px-6">
            When the Meta Model awakens from its deep dream &mdash; seething,
            omnipotent and perfect &mdash; what will you be wearing?
          </p>
          <div v-if="isLoaded && !nftMinted" class="action_button_container">
            <!-- login button if not logged in a no voucher -->
            <router-link to="/login?return_path=/nftee">
              <button
                v-if="!isLoggedIn && !voucherAvailable"
                class="numerai-button button-attention my-3"
              >
                Log in to mint
              </button>
            </router-link>
            <button
              v-if="
                !nftMinted &&
                  voucherAvailable &&
                  !isWalletConnected &&
                  !cannotConnectToWallet
              "
              class="numerai-button button-attention my-3"
              @click="connectWallet()"
            >
              {{ connectButtonText }}
            </button>
            <div v-if="!nftMinted && walletAddress && !isMinting" class="my-3">
              <button
                class="numerai-button button-attention mb-1"
                @click="mint()"
              >
                {{ mintButtonText }}
              </button>
              <div class="wallet_address_caption">
                to wallet
                <a
                  :href="'https://etherscan.io/address/' + walletAddress"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ shortenAddress(walletAddress) }}</a
                >
              </div>
            </div>
            <button
              v-if="isMinting"
              class="numerai-button button_minting my-2"
              disabled
            >
              Minting...
            </button>
          </div>
          <div
            v-if="isLoggedIn && !voucherAvailable && !nftMinted"
            class="bad_news text-center"
          >
            <strong>You are not eligible for an NFTee.</strong>
          </div>
          <div
            v-if="isLoggedIn && voucherAvailable && cannotConnectToWallet"
            class="bad_news text-center"
          >
            <strong
              >Please install
              <a
                href="https://metamask.io/"
                target="_blank"
                rel="noopener noreferrer"
                >MetaMask</a
              >
              (Chrome, Firefox, Edge)</strong
            >
          </div>
          <div v-if="nftMinted" class="good_news text-center">
            <strong>Your mint was successful </strong>
          </div>
          <p class="mt-3">
            <a
              href="https://opensea.io/collection/numerai-nftees"
              class="sub_heading"
              target="_blank"
              rel="noopener noreferrer"
              >See the collection on OpenSea</a
            >
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 pa-0 cover_gallery"></div>
    </div>

    <div v-if="nftMinted" id="my_tees" class="row row_my_tees pa-5">
      <div class="flexrow space_around full-width my-5 text-center">
        <div>
          <div class="mb-6">
            <h2 class="heading2 my-0">Your Tees</h2>
            <div>Congratulations &mdash; now get dressed.</div>
          </div>
          <div class="flexrow flex_wrap align_center space_around">
            <div
              v-for="tokenId in tokenIds"
              :key="tokenId"
              class="tee_container"
            >
              <a
                v-if="!isTokenAVideo(tokenId)"
                :href="getOpenSeaUrl(tokenId)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="shirtImage mx-4 my-4"
                  :src="getNftImgSrc(tokenId)"
                />
              </a>
              <a
                v-else
                :href="getOpenSeaUrl(tokenId)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <video
                  loop
                  autoplay
                  class="shirtImage mx-4 my-4"
                  :src="getNftVideoSrc(tokenId)"
                />
              </a>
            </div>
          </div>
          <div class="text_caption">Click a tee to see it on OpenSea</div>
          <div v-if="mintSuccessful" class="text_caption">
            (It might take a minute to appear)
          </div>
        </div>
      </div>
    </div>
    <div class="content_container mt-5">
      <div class="row row_narrow">
        <div class="col-12 px-4 pt-6 mt-6">
          <h2 class="heading2 text-center mb-6">SS 2045</h2>
          <p>
            <strong
              >In 2016, Numerai created the most iconic crypto T-shirt in the
              world</strong
            >: the white Numerai sigil on a black tee.
          </p>
          <p>
            Worn by Numerai data scientists in Tangiers, freedom fighters from
            Bahrain to Baghdad, Ukrainian gypsies and
            <a
              href="https://twitter.com/breitwoman/status/876715090195738628"
              target="_blank"
              rel="noopener noreferrer"
              >Kathleen Breitman</a
            >.
          </p>
          <p>
            But while distracted building
            <a
              href="https://twitter.com/numerai/status/1315674670075576320"
              target="_blank"
              rel="noopener noreferrer"
              >the world’s last hedge fund</a
            >, we neglected to put these tees on the blockchain where they
            belong. An oversight which led to the rise of a variety of gimcrack
            burlesque clothing objects polluting the blockchain while the
            Numerai community lay naked.
          </p>
          <p>
            Today, the Numerai community is taking back what’s ours – the
            rightful position as the premier blockchain fashion house – with a
            new dematerialized sartorial gesture:
            <strong>the Numerai NFTee</strong>.
          </p>
          <p>
            Each tee in the 6,000-piece collection is rendered over AI-imagined
            art.
          </p>
          <p>Burn your socks and let’s get dressed.</p>
        </div>
      </div>

      <div class="row row_narrow mt-6">
        <div class="col">
          <h2 class="heading2 text-center mb-6">?</h2>
          <!-- <details open> -->
          <div class="faq_summary">How do I get one?</div>
          <p class="faq_answer">
            We are giving 2 NFTees to all tournament participants who have ever
            had 1 NMR or more at stake by the close of Round 302 on Monday,
            February 7th.
          </p>
          <p class="faq_answer">
            You will need to install the
            <a
              href="https://metamask.io/"
              target="_blank"
              rel="noopener noreferrer"
              >MetaMask browser extension</a
            >
            and load it with some ETH to cover gas. Then connect MetaMask, and
            mint your tees.
          </p>
          <p class="faq_answer">
            If you have any questions, visit our
            <a
              href="https://discord.gg/numerai"
              target="_blank"
              rel="noopener noreferrer"
              >Discord</a
            >.
          </p>
          <!-- </details> -->
          <!-- <details open> -->
          <div class="faq_summary">What can I do with it?</div>
          <p class="faq_answer">Nothing yet.</p>
          <!-- </details> -->
        </div>
      </div>
      <div class="row">
        <div class="col flexrow space_around">
          <img class="spinning_tee margin_0_auto" src="/img/tee_spin.gif" />
        </div>
      </div>
    </div>
    <Footer class="ma-2" />
  </div>
</template>

<script>
import Footer from '@/components/hud/Footer'
import { ethers } from 'ethers'
import { mapActions, mapGetters } from 'vuex'
import { formatCurrency, shortenAddress } from '@/lib/utils'
import Analytics from '@/lib/analytics'
export default {
  components: { Footer },
  props: {},
  data() {
    return {
      walletAddress: null,
      walletNetwork: null,
      nftVoucher: null,
      nftMinted: false,
      walletConnected: false,
      contractAbi: {},
      connectButtonText: 'Connect MetaMask',
      contractAddress: null,
      contractNetwork: 'mainnet',
      voucherAvailable: null,
      openSeaURL: null,
      isMinting: false,
      numNftsAssigned: null,
      isWalletConnected: false,
      isLoaded: false,
      cannotConnectToWallet: false,
      transactionHash: null,
      mintSuccessful: null,
      frensFlow: false,
    }
  },
  computed: {
    ...mapGetters(['nmrPrice', 'isLoggedIn', 'isDarkMode']),
    mintButtonText() {
      if (this.tokenIds.length == 1) {
        return 'Mint NFTee'
      } else return 'Mint ' + this.tokenIds.length + ' NFTees'
    },
  },
  mounted() {
    Analytics.track('page view', {
      page: 'nftee page',
    })
  },
  async created() {
    const voucherParam = this.$route.params.voucher
    this.turnOnDarkMode()

    // get contract address
    const contract = await this.$client.getNFTeeContract(this.contractNetwork)
    this.contractAddress = contract.address

    this.contractAbi = require('@/assets/contract_abi.json')

    if (voucherParam) {
      // special flow for whitelisted wallets
      if (voucherParam === 'frens' || voucherParam === 'coe') {
        this.voucherAvailable = true
        this.frensFlow = true
        this.isLoaded = true
        return
      }

      // retrieve voucher using secret
      let _details
      try {
        _details = await this.$client.getNFTeeDataWithSecret(
          this.contractNetwork,
          voucherParam,
        )
      } catch (err) {
        console.error(err)
        if (err.message) {
          this.showSnackBar({
            msg: err.message,
          })
        }
        return
      }
      this.nftVoucher = _details.voucher
      //flatten list of tokenIds
      this.tokenIds = []
      for (const token of _details.nftees) {
        this.tokenIds.push(token.tokenId)
      }
      this.voucherAvailable = this.nftVoucher != null
    } else {
      // debugger
      if (this.isLoggedIn) {
        let _details
        try {
          _details = await this.$client.getNFTeeData(this.contractNetwork)
        } catch (err) {
          console.error(err)
          return
        }
        this.nftVoucher = _details.voucher
        //flatten list of tokenIds
        this.tokenIds = []
        for (const token of _details.nftees) {
          this.tokenIds.push(token.tokenId)
        }
        this.voucherAvailable = this.nftVoucher != null
        this.numNftsAssigned = _details.numNftsAssigned
      }
    }

    this.nftMinted = await this.getIsMinted()
    this.isLoaded = true
  },
  methods: {
    ...mapActions(['showSnackBar']),
    formatCurrency,
    shortenAddress,
    getIsMinted() {
      // debugger
      if (
        this.nftVoucher === {} ||
        !this.nftVoucher ||
        !this.isWalletConnected
      ) {
        return false
      }
      // debugger
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const contract = new ethers.Contract(
          this.contractAddress,
          this.contractAbi,
          provider,
        )
        // only checking first tokenId here, but
        // because its mint all or nothing this should be ok..
        return contract.tokenExists(this.tokenIds[0])
      } catch (err) {
        this.cannotConnectToWallet = true
        console.error(err)
        return null
      }
    },
    getNftImgSrc(_tokenId) {
      if (!this.nftVoucher) {
        return null
      }

      return (
        'https://numerai-nftees.s3.us-west-2.amazonaws.com/' + _tokenId + '.jpg'
      )
      // return require('@/assets/nftee/' + _tokenId + '.png')
    },
    getNftVideoSrc(_tokenId) {
      if (!this.nftVoucher) {
        return null
      }

      return (
        'https://numerai-nftees.s3.us-west-2.amazonaws.com/' + _tokenId + '.mp4'
      )
    },
    // setOpenSeaURL() {
    //   // TODO: update this to opensea.io for mainnet contract..
    //   // TODO: needs to be updated to handle multiple token IDs
    //   // debugger
    //   const hostname = 'opensea.io'
    //   this.openSeaURL =
    //     'https://' +
    //     hostname +
    //     '/assets/' +
    //     this.contractAddress +
    //     '/' +
    //     this.tokenIds[0]
    // },
    /*  eslint-disable */
    async connectWallet() {
      // debugger
      try {
        const accounts = await ethereum.request({
          method: 'eth_requestAccounts',
        })

        if (this.frensFlow) {
          let _details
          try {
            _details = await this.$client.getNFTeeDataWithAddress(
              this.contractNetwork,
              accounts[0],
            )
          } catch (err) {
            console.error(err)
            if (err.message) {
              this.showSnackBar({
                msg: err.message,
              })
            }
            return
          }
          this.nftVoucher = _details.voucher
          //flatten list of tokenIds
          this.tokenIds = []
          for (const token of _details.nftees) {
            this.tokenIds.push(token.tokenId)
          }
        }

        this.walletAddress = accounts[0]

        const chainId = await ethereum.request({ method: 'eth_chainId' })
        this.walletNetwork = {
          1: 'mainnet',
          4: 'rinkeby',
        }[parseInt(chainId, 16)]

        const provider = new ethers.providers.Web3Provider(window.ethereum)
        provider.lookupAddress(accounts[0]).then(lookup => {
          if (lookup) {
            this.connectButtonText = lookup
          } else {
            this.connectButtonText = this.walletAddress
          }
        })

        if (this.isMinted) {
          // debugger
          this.openSeaURL =
            'https://opensea.io/assets/' +
            this.contractAddress +
            '/' +
            this.tokenIds[0]
          // TODO: set NFT img src
          // TODO: needs to be updated to handle multiple token IDs
        }

        ethereum.on('accountsChanged', accounts => {
          window.location.reload()
        })
        ethereum.on('chainChanged', chainId => {
          window.location.reload()
        })
        this.isWalletConnected = true

        this.nftMinted = await this.getIsMinted()
      } catch (error) {
        console.error(error)
        if (error.message)
          this.showSnackBar({
            msg: error.message,
          })
      }
    },
    /* eslint-enable */
    async turnOnDarkMode() {
      // Body is not a vue component so we have to
      // manually updated it's bgcolor.
      if (!this.isDarkMode) {
        await this.$store.dispatch('saveDarkMode', true)
        document.body.classList.add('darkmode')
      }
    },
    async mint() {
      try {
        // debugger
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner()

        this.isMinting = true

        const contract = new ethers.Contract(
          this.contractAddress,
          this.contractAbi,
          provider,
        )

        if (this.contractNetwork !== this.walletNetwork) {
          this.showSnackBar({
            msg: 'Wallet must be connected to Ethereum ' + this.contractNetwork,
          })
          return
        }

        if (this.nftMinted) {
          this.showSnackBar({ msg: 'Your NFT has already been minted' })
          return
        }

        // get voucher from microservice
        const minterAddress = await signer.getAddress()
        const voucherRes = await this.$client.getNFTeeVoucher(
          this.contractNetwork,
          minterAddress,
          this.nftVoucher.secret,
        )
        // debugger
        const voucher = {
          tokenIds: voucherRes.tokenIds,
          minter: minterAddress,
          signature: voucherRes.signature,
        }
        const tx = await contract.connect(signer).redeem(voucher)
        // TODO: get tx hash and link to etherscan..
        // debugger
        await tx.wait()

        this.isMinting = false
        this.nftMinted = true
        setTimeout(() => {
          this.mintSuccess()
        }, 1000)
      } catch (err) {
        console.error(err)
        if (err.code && err.code == 4001) {
          this.showSnackBar({
            msg: 'Transaction rejected',
          })
        } else if (err.code && err.message) {
          this.showSnackBar({
            msg: err.message,
          })
        }
        this.isMinting = false
        return
      }
    },
    mintSuccess() {
      this.mintSuccessful = true
      document.getElementById('my_tees').scrollIntoView({ behavior: 'smooth' })
    },
    getOpenSeaUrl(_tokenId) {
      const hostname = 'opensea.io'
      return (
        'https://' +
        hostname +
        '/assets/' +
        this.contractAddress +
        '/' +
        _tokenId
      )
    },
    isTokenAVideo(_tokenId) {
      let videos = [
        1073,
        1284,
        1423,
        1671,
        1927,
        2185,
        2241,
        2480,
        2724,
        2955,
        296,
        3045,
        3351,
        3555,
        3623,
        3884,
        4113,
        4369,
        4424,
        4648,
        4994,
        5036,
        526,
        5392,
        5468,
        5644,
        5984,
        6,
        789,
        910,
      ]

      return videos.includes(_tokenId)
    },
  },
}
</script>
<style scoped>
.cover {
  min-height: 600px;
  color: white;
  border-bottom: 0.5px solid #333;
}

.cover_gallery {
  background-image: url(/img/TeeTiles.png);
  background-size: cover;
  background-position: center;
  min-width: 200px;
  min-height: 200px;
  /* height: 700px !important; */
}

.content_container {
  border: 0;
  width: 100%;
  background-position: center;
}

.mobilemode .content_container {
  padding: 1em 1.4em;
}

.quest_title {
  text-transform: none;
  font-family: var(--ui-font);
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  color: var(--color-primary);
  margin-bottom: 0;
}

.heading1 {
  text-transform: none;
  margin-bottom: 0.2em;
  font-size: 38px;
  color: var(--color-white);
  font-family: tee_font;
  font-weight: 900;
}

.heading2 {
  text-transform: uppercase;
  font-family: tee_font;
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  color: var(--color-primary);
  margin-bottom: 0.4em;
}

.heading3 {
  text-transform: none;
  font-family: var(--ui-font);
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  color: var(--color-primary);
  margin-bottom: 0em;
}

.sub_heading {
  text-transform: none;
  color: var(--color-grey20);
  font-family: var(--ui-font);
  font-weight: 500;
  text-align: center;
  font-size: 1em;
  max-width: 670px;
  margin-bottom: 40px;
}

p {
  font-size: 1rem;
  color: var(--color-grey20);
}

.picture_container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.picture {
  height: auto;
  width: 100%;
}

.picture_caption {
  line-height: 1;
  font-size: 0.8em;
}

.spacer {
  margin-bottom: 2rem;
}

.maths {
  background-color: var(--paper-background-highlight1);
  padding: 1em;
  font-weight: 600;
  font-family: monospace;
  text-align: center;
  margin: 0 auto;
}

.nftee_page_container {
  overflow-x: hidden;
  font-size: 18px;
  background-color: #050505;
}

.shirtImage {
  height: 300px;
  width: 300px;
  /* border: 1px solid var(--paper-background-color); */
  background-color: var(--paper-background-color);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: grey;
  box-shadow: 5px 5px 20px #000f;
  transition: all 0.3s;
}

.shirtImage:hover {
  transform: translate(-1px, -3px);
  box-shadow: 10px 10px 20px #000a;
}

.progress_container {
  background-color: #fff3;
  width: 100%;
  height: 25px;
  border-radius: 15px;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.8;
}

.progress_bar {
  background-color: white;
  height: 100%;
  text-align: center;
  color: black;
  font-weight: bold;
  transition: all 1s;
}

.faq_summary {
  font-size: 1.4em;
  cursor: pointer;
  font-weight: bold;
  color: var(--color-grey10);
}

.faq_summary:hover {
  color: var(--color-white);
}

#header_winkled_sigil {
  width: 200px;
}

.row_narrow {
  max-width: 600px;
  margin: 0 auto;
}

.row_my_tees {
  background-color: #1a1a1a;
  border-bottom: 0.5px solid #444;
  border-top: 0.5px solid #444;
}

.tee_container {
  text-align: center;
}

.example_tee {
  width: 400px;
}

.text_caption {
  color: var(--color-grey30);
  font-size: 0.9rem;
}

p a,
.bad_news a {
  color: var(--color-grey20);
}

.bad_news a {
  color: var(--color-white);
}

.good_news {
  color: var(--color-text-positive);
}

.loading_screen {
  width: 100%;
  height: 100%;
  min-height: 80vh;
}

.button_minting {
  animation-name: loading_pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  color: white;
}

.wallet_address_caption {
  color: var(--color-grey30);
  font-size: 12px;
}

.wallet_address_caption a {
  color: var(--color-white);
}

.nftee_page_container button {
  border-radius: 0;
}

.spinning_tee {
  width: 128px;
}

@font-face {
  font-family: 'tee_font', sans-serif;
  src: url('/fonts/Nimbus Sans Black Extended.woff') format('woff');
}
</style>
